import * as React from 'react';

// Hooks
import { useRangeLabel } from '../../../../../hooks/useRangeLabel';

// Types
import { ISalaryRangeMeta } from '../../../../../types';

interface IWageRangeLabelProps {
    meta: ISalaryRangeMeta;
}

export const WageRangeLabel: React.FC<IWageRangeLabelProps> = ({ meta }) => {
    const { getRangeLabel } = useRangeLabel();
    const { sectionLabel } = getRangeLabel(meta);

    return <>{sectionLabel}</>;
};
